<!-- TODO: Write the current report paramenters
Name: <b class="f-s-75-2">{{ selectedUser }}</b>
<span class="soft-pipe"> |</span>
Selected Role: <b class="f-s-75-2">{{ selectedRole }}</b>
<span class="soft-pipe"> |</span>
Selected Date:
<b class="f-s-75-2">{{ selectedDate | cmpsDate: "y-MM-dd h:mm a" }}</b> -->

<div
    class="plotter"
    *ngIf="plotData"
>
    <ng-chart-chart
        [options]="_chartOptions"
        [data]="_chartData"
        (pointMouseOver)="_onPointMouseOver($event)"
        (pointMouseOut)="_onPointMouseOut()"
    ></ng-chart-chart>
</div>
<div
    class="legendTable"
    *ngIf="plotData"
>
    <table>
        <tr class="tableTitle">
            <th colspan="2">
                <b class="f-s-75-2">Selected Date Range</b>
            </th>
        </tr>
        <tr class="tableTitle">
            <th colspan="2">
                {{ startDate | cmpsDate: 'yyyy-MM-dd' }} /
                {{ selectedDate | cmpsDate: 'yyyy-MM-dd' }}
            </th>
        </tr>
        <tr>
            <td><b>Outcome:</b> {{ outcomeTargetName }}</td>
            <td>
                <div class="legend">
                    <div class="dashLine"></div>
                    Targets selected by user ({{ selectedUser }})
                </div>
            </td>
        </tr>
        <tr>
            <td><b>Behaviour:</b> {{ behaviourTargetName }}</td>
            <td>
                <div class="legend">
                    <div class="redCircle"></div>
                    Direct Report
                </div>
            </td>
        </tr>
    </table>
</div>

<ng-template
    let-data="data"
    #callout
>
    <div class="cmps-scatterplot--callout-handle">
        <table>
            <thead>
                <tr>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="cmps-scatterplot--callout">
                        <span
                            >Behavior (Active):&nbsp;{{
                                data?.d?.x | cmpsNumber: '1.2-2'
                            }}</span
                        >
                    </td>
                </tr>
                <tr>
                    <td>
                        <span
                            >Outcome (Active):&nbsp;{{
                                data?.d?.y | cmpsNumber: '1.2-2'
                            }}</span
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>
